import {
  AfterViewInit,
  Component,
  HostListener,
  Inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/operators';
import { MarketplaceProfileComponent } from 'src/app/customers/layout/component-layout/marketplace-profile/marketplace-profile.component';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { MemberNotificationService } from 'src/app/shareModule/services/member-notification.service';
import { ModalService } from 'src/app/shareModule/services/modal.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SignInComponent } from '../component-layout/sign-in/sign-in.component';
import { ShepherdService } from 'angular-shepherd';
import { Subscription } from 'rxjs';
import { loadUser } from 'src/app/shareModule/states/user-details/user-details.action';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/shareModule/states/app.state';
import { SeoService } from 'src/app/shareModule/services/seo.service';

declare var Swiper: any;

@Component({
  selector: 'app-customers-layout-referral',
  templateUrl: './customers-layout-referral.component.html',
  styleUrls: ['./customers-layout-referral.component.scss'],
})
export class CustomersLayoutReferralComponent implements OnInit, AfterViewInit {
  @ViewChild('SignIn', { static: false }) signIn: SignInComponent;
  @ViewChild('MarketplaceProfile')
  marketplaceProfileSection: MarketplaceProfileComponent;

  public navbarVisible: boolean = true;
  public navbarScroll: boolean = true;
  public modalRef: any;
  private lastScrollTop = 0;
  submitted = false;
  isUserLogin: number = 0;
  appUserId: any = 0;
  showFloatingMenu: boolean = false;
  showPage: string = 'main';
  menuSliderLeft = false;
  tabMenuLeft: boolean = true;
  menuItem: any = {};
  menuItems: any = [];
  sloganText: string = 'We Recommend the Good Stuff';
  menuItemsInfo: any = [];
  isNewMessage: boolean = false;
  customerService: boolean = false;
  isReferralLink: boolean = false;
  referralCode: string = '';
  shopProfile: any = {};

  constructor(
    public auth: AuthServiceService,
    private router: Router,
    private local: LocalServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private memberNotificationService: MemberNotificationService,
    public sharedService: SharedService,
    private myModalService: ModalService,
    public roleService: RoleService,
    private shepherdService: ShepherdService,
    private route: ActivatedRoute,
    @Inject("WINDOW") private window: any,
    private store: Store<AppState>,
    private seoService: SeoService
  ) {
  }

  ngAfterViewInit(): void {
    this.getWizardPosition()

  }
  showMessagePopup: boolean = false;
  messageData = { title: '', description: 'this is not a drill' }
  messagePopupPos: any = { bottom: 0, right: 0 };


  @HostListener('window:resize', ['$event'])
  private getWizardPosition() {
    const element = document.querySelector(`.floating-menu`) as HTMLElement;
    if (element) {
      //const rect = element.getBoundingClientRect();
      this.messagePopupPos = {
        bottom: "12em",
        right: "3em"
      }


    } else {
      console.error("Unable to find wizard's location")
    }

  }
  bizMessages = []

  private messageChangeInterval: any = null;

  private setMessageChangeInterval() {
    if (this.sharedService.isBrowser()) {
      this.stopMessageChangeInterval();
      if (this.bizMessages.length < 2) {
        return; //no need to change
      }

      let curreIndex = 0;
      this.messageChangeInterval = setInterval(() => {
        this.messageData.description = this.bizMessages[curreIndex].message

        curreIndex++;
        curreIndex %= this.bizMessages.length

      }, 5_000);

    }


  }
  private stopMessageChangeInterval() {
    if (this.sharedService.isBrowser()) {
      if (this.messageChangeInterval) {
        clearInterval(this.messageChangeInterval);
        this.messageChangeInterval = null;
      }
    }


  }

  ngOnInit(): void {
    this.sharedService.profileService$.subscribe((data) => {
      this.shopProfile = data;

      this.auth.getAllBizMessages(this.shopProfile.id).subscribe({
        next: (data) => {
          if (!this.local.getUser()) {
            this.bizMessages = Array.from(data.data.filter(data => !data.isForLoginUserOnly))
          } else {
            this.bizMessages = data.data

          }
          this.setMessageChangeInterval();


          if (this.bizMessages.length) {
            this.messageData.description = this.bizMessages[0].message
            this.showMessagePopup = true

          } else {
            this.showMessagePopup = false;
          }
        }
      })
    });

    this.route.queryParams.subscribe((params) => {
      if (params['code']) {
        this.isReferralLink = true;
        this.referralCode = params['code'];
      } else {
        this.isReferralLink = false;
      }
    });

    if (this.window.location.hostname === 'sgbojio.com') {
      this.sloganText = 'Good things must be Shared';
    }

    this.checkPage();
    //this.local.fetchUser();
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.appUserId = user.id;
        this.isUserLogin = 1;
        this.local.periodicallyCheckLoginUserData(true);
        this.store.dispatch(loadUser({}));
      } else {
        this.isUserLogin = 0;
      }
      this.menuItemsInfo = this.menuItemsInfo.map((item) => {
        return {
          ...item,
          condition: item.condition === 'auth' ? this.isUserLogin === 1 : true,
        };
      }).filter(item => item.condition); // Filter out items where condition is false
    });

    if (this.sharedService.isBrowser()) {
      if (localStorage.getItem('selectedTheme') === 'space') {
        document.documentElement.classList.add('space');
      } else if (localStorage.getItem('selectedTheme') === 'beige') {
        document.documentElement.classList.add('beige');
      } else if (localStorage.getItem('selectedTheme') === 'winter') {
        document.documentElement.classList.add('winter');
      } else if (localStorage.getItem('selectedTheme') === 'bronze') {
        document.documentElement.classList.add('bronze');
      }
    }
  }
  private navigationSubscription: Subscription;
  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    this.stopMessageChangeInterval();
    this.showMessagePopup = false;
  }

  private stopShepherdTour() {
    // Stop the Shepherd tour
    if (this.shepherdService?.complete) {
      this.shepherdService.complete(); // or use .cancel() if you prefer to cancel the tour
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollTop = this.window.pageYOffset || document.documentElement.scrollTop;
    if (
      (scrollTop > this.lastScrollTop && scrollTop != 0) ||
      this.window.innerHeight + this.window.scrollY >=
      document.documentElement.scrollHeight
    ) {
      this.navbarVisible = false;
    } else {
      this.navbarVisible = true;
    }
    this.lastScrollTop = scrollTop;
  }

  timeoutId: any; // Variable to store the timeout ID
  openProfilePopup(tab) {
    this.marketplaceProfileSection.tab = tab;
    this.marketplaceProfileSection
      ? (this.marketplaceProfileSection.showProfileMenu = true)
      : '';
    document.body.style.overflow = 'hidden';
  }
  checkPage() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.showMessagePopup = false
        this.showPage = event.urlAfterRedirects; // or event.url if you want the original URL
      });
  }

  openShopSignoutPopup(modal) {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'shop_signin_pop',
    });
    // this.router.navigateByUrl('/');
  }

  modalDismissAll() {
    this.modalService.dismissAll();
  }

  shopLogout() {
    this.auth.logout_customer_marketplace({ id: this.appUserId }).subscribe(
      (response: ApiResponse) => {
        this._clearUserDataAfterLogout(response);
      },
      ({ error }: any) => {
        this._clearUserDataAfterLogout(error);
      }
    );
    //this.local.fetchUser();
  }

  private _clearUserDataAfterLogout(response: any) {
    this.modalDismissAll();
    response?.message ? this.toastr.success(response.message) : '';
    this.memberNotificationService.clearNotification();
    this.local.logout();
  }

  openSigninModal() {
    this.signIn.loginStage = '';
    this.signIn.withoutSteps = true
    this.signIn.openSignInPopup();
  }

  goToProfile() {
    if (this.route.snapshot.url.some(segment => segment.path === 'share')) {
      this.router.navigate([`/share/${this.route.snapshot.params.shop}/settings`], { queryParams: this.route.snapshot.queryParams });
    } else {
      this.router.navigate([`/brand/settings`], { queryParams: this.route.snapshot.queryParams });
    }
  }
}
